import { AppContextImpl, AppContext } from "./application-context";
import { appContextPersistenceKey } from "./application-context-service";
import * as Jsll from "../../../ShellCommon/logger/jsll-types";

export type WindowWithJsll = ng.IWindowService & {
  awa: Jsll.AwaStatic;
};

export class ApplicationContextFactory {
  private static contextInstance: AppContextImpl;

  public static create(): AppContextImpl {
    let jsllWindow = window as any as WindowWithJsll;

    if (!ApplicationContextFactory.contextInstance) {
      // Initialize Asimov correlation vector
      jsllWindow.awa.cv.init();

      // If we have a saved context, use it
      let appContext: AppContextImpl;
      let savedAgentContextRaw = jsllWindow.localStorage.getItem(appContextPersistenceKey);
      if (savedAgentContextRaw) {
        appContext = JSON.parse(savedAgentContextRaw) as AppContextImpl;
        if (appContext.applicationCV) {
          jsllWindow.awa.cv.setValue(appContext.applicationCV);
        }
        appContext.applicationCV = jsllWindow.awa.cv.increment();
        appContext.windowCV = jsllWindow.awa.cv.extend();
      } else {
        appContext = this.createDefaultAppContext(jsllWindow);
        jsllWindow.awa.cv.setValue(appContext.windowCV);
      }
      ApplicationContextFactory.contextInstance = appContext;
    }

    return Object.assign({}, ApplicationContextFactory.contextInstance);
  }

  private static createDefaultAppContext(jsllWindow: WindowWithJsll): AppContext {
    let applicationCV = jsllWindow.awa.cv.getValue();
    let windowCV = jsllWindow.awa.cv.extend();
    return {
      agentEmail: undefined,
      agentPuid: undefined,
      vendorSiteId: undefined,
      vendorSiteName: undefined,
      agentDisplayName: undefined,
      agentProfileImageUrl: undefined,
      creationTime: new Date(),
      agentId: undefined,
      agentUpn: undefined,
      windowCV: windowCV,
      applicationCV: applicationCV,

      agentMode: undefined
    };
  }

  public static reset(): void {
    this.contextInstance = undefined;
  }
}
